import InfoWindow from '../Close';

export default class {

    constructor(google,map) 
    {
        this.infoWindow =  document.getElementById('detect-geo');
        this.close = document.getElementById('detect-geo');
        this.close.addEventListener('click',this,false);
        this.google = google;
        this.map    = map;

    }
    
    handleEvent(evt)
    {
        console.log(this.google);

        InfoWindow.close();

        var google = this.google;
        var map   = this.map;

        if(navigator.geolocation)
        {

            navigator.geolocation.getCurrentPosition( (position) => {

                let lat = position.coords.latitude;
                let lng = position.coords.longitude;
                let positionMap = new google.LatLng(lat,lng);

                new google.Marker({
                    position : positionMap,
                    map      : map,
                    icon     : '/wp-content/themes/dt-the7-child/assets/icons/location.png',
                })

                map.setCenter(positionMap);
                map.setZoom(14);

            });
            
        }else{
            alert("Navegador no soportado");
        }
        
    }
}
